import React from 'react';
import { useDropzone, DropzoneOptions } from 'react-dropzone';
import { FormattedMessage } from 'react-intl';
import { Spinner } from '../core/spinner';
import { cn } from '../../helpers/classnames';

interface InstantUploadDropperProps {
  disabled?: boolean;
  dropzoneOptions?: DropzoneOptions;
}

const InstantUploadDropperProps: React.FC<InstantUploadDropperProps> = ({
  disabled,
  dropzoneOptions,
}) => {
  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
  } = useDropzone(dropzoneOptions);

  return (
    <div
      {...getRootProps({
        className: cn(
          'flex min-h-[150px] min-w-[300px] flex-1 cursor-pointer flex-col items-center rounded-sm border-2 border-dashed p-5 outline-none transition-colors duration-200',
          'border-[#eeeeee] bg-[#fafafa] text-[#bdbdbd]',
          isDragActive && 'border-[#2196f3]',
          isDragAccept && 'border-[#00e676]',
          isDragReject && 'border-[#ff1744]',
        ),
      })}
    >
      <input disabled={disabled} {...getInputProps()} />
      {disabled ? (
        <p>
          <Spinner />
        </p>
      ) : isDragActive ? (
        <p>
          <FormattedMessage
            id="instant_upload_dropper.drop_file_here"
            defaultMessage="Drop file here..."
          />
        </p>
      ) : (
        <p>
          <FormattedMessage
            id="instant_upload_dropper.drag_or_click"
            defaultMessage="Drag a file here, or click to select"
          />
        </p>
      )}
    </div>
  );
};

export default InstantUploadDropperProps;
